import { ChevronUp, ChevronDown } from 'lucide-react';

interface SortThProps {
  label: string;
  field: string;
  sortBy: string;
  sortDir: 'asc' | 'desc';
  onSort: (field: string) => void;
  className?: string;
}

export default function SortTh({ label, field, sortBy, sortDir, onSort, className = '' }: SortThProps) {
  const active = sortBy === field;
  return (
    <th
      className={`text-xs font-bold uppercase tracking-wider py-3.5 px-4 text-left cursor-pointer select-none group/th hover:text-white transition-colors whitespace-nowrap ${active ? 'text-white' : 'text-fieldiq-muted'} ${className}`}
      onClick={() => onSort(field)}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        <span className="inline-flex flex-col leading-none">
          <ChevronUp className={`w-4 h-4 -mb-[4px] ${active && sortDir === 'asc' ? 'text-fieldiq-accent' : 'text-fieldiq-muted/40 group-hover/th:text-fieldiq-muted/60'}`} />
          <ChevronDown className={`w-4 h-4 -mt-[4px] ${active && sortDir === 'desc' ? 'text-fieldiq-accent' : 'text-fieldiq-muted/40 group-hover/th:text-fieldiq-muted/60'}`} />
        </span>
      </span>
    </th>
  );
}

/** Generic sort comparator for use with Array.sort() */
export function sortCompare(aVal: any, bVal: any, dir: 'asc' | 'desc'): number {
  let cmp = 0;
  if (aVal == null && bVal == null) cmp = 0;
  else if (aVal == null || aVal === '') cmp = 1;
  else if (bVal == null || bVal === '') cmp = -1;
  else if (typeof aVal === 'number' && typeof bVal === 'number') cmp = aVal - bVal;
  else cmp = String(aVal).localeCompare(String(bVal), undefined, { numeric: true, sensitivity: 'base' });
  return dir === 'asc' ? cmp : -cmp;
}

/** Toggle sort helper — call from your component */
export function makeToggleSort(
  setSortBy: (field: string) => void,
  setSortDir: (fn: (prev: 'asc' | 'desc') => 'asc' | 'desc') => void,
  currentSortBy: string
) {
  return (field: string) => {
    if (currentSortBy === field) {
      setSortDir((d: 'asc' | 'desc') => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(field);
      setSortDir(() => 'asc');
    }
  };
}
